export function PublicIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.04213 8.26667C5.04213 5.91025 6.96337 4 9.33333 4C11.7033 4 13.6245 5.91025 13.6245 8.26667C13.6245 10.6231 11.7033 12.5333 9.33333 12.5333C6.96337 12.5333 5.04213 10.6231 5.04213 8.26667ZM9.33333 6.13333C8.14835 6.13333 7.18773 7.08846 7.18773 8.26667C7.18773 9.44488 8.14835 10.4 9.33333 10.4C10.5183 10.4 11.4789 9.44488 11.4789 8.26667C11.4789 7.08846 10.5183 6.13333 9.33333 6.13333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33333 13.6C7.5122 13.6 6.19901 14.2843 5.32951 15.2688C4.49104 16.2181 4.12792 17.3721 4.01334 18.2676C3.883 19.2864 4.72995 20 5.57853 20H13.0881C13.9367 20 14.7837 19.2864 14.6533 18.2676C14.5387 17.3721 14.1756 16.2181 13.3372 15.2688C12.4677 14.2843 11.1545 13.6 9.33333 13.6ZM11.725 16.6764C12.0351 17.0276 12.246 17.4495 12.3774 17.8667H6.28931C6.42064 17.4495 6.6316 17.0276 6.94171 16.6764C7.39102 16.1677 8.10987 15.7333 9.33333 15.7333C10.5568 15.7333 11.2756 16.1677 11.725 16.6764Z"
        fill="currentColor"
      />
      <path
        d="M12.8889 12.1511C13.4306 12.3966 14.0325 12.5333 14.6667 12.5333C17.0366 12.5333 18.9579 10.6231 18.9579 8.26667C18.9579 5.91025 17.0366 4 14.6667 4C14.0325 4 13.4306 4.13676 12.8889 4.38223C14.3716 5.05417 15.4023 6.54075 15.4023 8.26667C15.4023 9.99259 14.3716 11.4792 12.8889 12.1511Z"
        fill="currentColor"
      />
      <path
        d="M14.8659 20H18.4215C19.2701 20 20.117 19.2864 19.9867 18.2676C19.8721 17.3721 19.509 16.2181 18.6705 15.2688C17.801 14.2843 16.4878 13.6 14.6667 13.6C14.0088 13.6 13.4172 13.6893 12.8889 13.8498C13.8231 14.1335 14.5595 14.6399 15.1149 15.2688C15.9534 16.2181 16.3165 17.3721 16.4311 18.2676C16.5614 19.2864 15.7145 20 14.8659 20Z"
        fill="currentColor"
      />
    </svg>
  );
}
